import { Type } from 'class-transformer';
import {
  ArrayMaxSize,
  IsArray,
  IsBoolean,
  IsObject,
  IsString,
  MinLength,
  ValidateNested,
} from 'class-validator';
import type { AnswerValue } from '../../survey/survey-answers.types';

export class ConfirmedImportAnswerDto {
  @IsString()
  @MinLength(1)
  answerKey!: string;

  @IsObject()
  value!: AnswerValue;
}

export class ConfirmManualImportDto {
  @IsArray()
  @ArrayMaxSize(2000)
  @ValidateNested({ each: true })
  @Type(() => ConfirmedImportAnswerDto)
  answers!: ConfirmedImportAnswerDto[];

  @IsBoolean()
  replaceExistingDraft!: boolean;
}
